import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'sonner';
import { useAuth } from '@/contexts/AuthContext';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const SecurityVisitorRegistry = () => {
  const [visitors, setVisitors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');
  const { user } = useAuth();

  useEffect(() => {
    fetchVisitors();
  }, []);

  const fetchVisitors = async () => {
    try {
      const response = await axios.get(`${API}/visitors`);
      setVisitors(response.data);
    } catch (error) {
      console.error('Error fetching visitors:', error);
      toast.error('Error al cargar registros de visitantes');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const filteredVisitors = visitors.filter(v => {
    if (filter === 'all') return true;
    if (filter === 'pending') return v.status === 'pending';
    if (filter === 'used') return v.status === 'used';
    return true;
  });

  const stats = {
    total: visitors.length,
    pending: visitors.filter(v => v.status === 'pending').length,
    used: visitors.filter(v => v.status === 'used').length
  };

  if (loading) {
    return <div className="loading">Cargando...</div>;
  }

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">Registros de Visitantes</h1>
        <Link to="/security" className="btn-back">
          ← Volver
        </Link>
      </div>

      <div className="stats-section">
        <div className="stat-card">
          <div className="stat-value">{stats.total}</div>
          <div className="stat-label">Total</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{stats.pending}</div>
          <div className="stat-label">Pendientes</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{stats.used}</div>
          <div className="stat-label">Utilizados</div>
        </div>
      </div>

      <div className="filters-section">
        <div className="filter-group">
          <label htmlFor="status-filter">Filtrar por estado:</label>
          <select
            id="status-filter"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
          >
            <option value="all">Todos</option>
            <option value="pending">Pendientes</option>
            <option value="used">Utilizados</option>
          </select>
        </div>
      </div>

      {filteredVisitors.length === 0 ? (
        <div className="empty-state">
          <p>No hay visitantes registrados</p>
        </div>
      ) : (
        <div className="table-container">
          <table className="history-table">
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Tipo</th>
                <th>Área</th>
                <th>Placa</th>
                <th>Estado</th>
                <th>Fecha Creación</th>
                <th>Fecha Escaneo</th>
              </tr>
            </thead>
            <tbody>
              {filteredVisitors.map((visitor) => (
                <tr key={visitor.id}>
                  <td className="visitor-name-cell">{visitor.name}</td>
                  <td>
                    <span className="visitor-type">{visitor.visitor_type}</span>
                  </td>
                  <td>
                    <span className="area-badge">{visitor.area}</span>
                  </td>
                  <td>{visitor.vehicle_plate || '-'}</td>
                  <td>
                    <span className={`visitor-status ${
                      visitor.status === 'pending' ? 'status-pending' : 'status-used'
                    }`}>
                      {visitor.status === 'pending' ? 'Pendiente' : 'Utilizado'}
                    </span>
                  </td>
                  <td>{formatDate(visitor.created_at)}</td>
                  <td>{visitor.scanned_at ? formatDate(visitor.scanned_at) : '-'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default SecurityVisitorRegistry;
